import * as React from 'react';

const SvgDiscardSelection = (props) => (
  <svg
    width={140}
    height={122}
    viewBox="0 0 140 122"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_409_2859)">
      <path
        d="M70.188 106.493C98.188 106.493 120.888 83.7933 120.888 55.6933C120.888 27.5933 98.088 4.89331 70.188 4.89331C42.188 4.89331 19.488 27.5933 19.488 55.6933C19.488 83.7933 42.188 106.493 70.188 106.493Z"
        fill="#EAEEF9"
      />
      <path
        d="M117.588 22.3936C119.852 22.3936 121.688 20.5579 121.688 18.2936C121.688 16.0292 119.852 14.1936 117.588 14.1936C115.324 14.1936 113.488 16.0292 113.488 18.2936C113.488 20.5579 115.324 22.3936 117.588 22.3936Z"
        fill="#EAEEF9"
      />
      <path
        d="M123.588 6.39346C125.134 6.39346 126.388 5.13985 126.388 3.59346C126.388 2.04706 125.134 0.793457 123.588 0.793457C122.042 0.793457 120.788 2.04706 120.788 3.59346C120.788 5.13985 122.042 6.39346 123.588 6.39346Z"
        fill="#EAEEF9"
      />
      <path
        d="M22.1881 22.2936C23.7345 22.2936 24.9881 21.04 24.9881 19.4936C24.9881 17.9472 23.7345 16.6936 22.1881 16.6936C20.6417 16.6936 19.3881 17.9472 19.3881 19.4936C19.3881 21.04 20.6417 22.2936 22.1881 22.2936Z"
        fill="#EAEEF9"
      />
      <path
        d="M10.4061 82.8216C13.2779 82.8216 15.6061 80.4935 15.6061 77.6216C15.6061 74.7497 13.2779 72.4216 10.4061 72.4216C7.53418 72.4216 5.20605 74.7497 5.20605 77.6216C5.20605 80.4935 7.53418 82.8216 10.4061 82.8216Z"
        fill="#EAEEF9"
      />
      <g filter="url(#filter0_d_409_2859)">
        <path
          d="M110.65 88.8399H29.7252C26.0045 88.8399 22.9814 85.8169 22.9814 82.0962V30.2389C22.9814 26.5182 26.0045 23.4951 29.7252 23.4951H110.65C114.371 23.4951 117.394 26.5182 117.394 30.2389V82.3287C117.162 85.8169 114.139 88.8399 110.65 88.8399Z"
          fill="url(#paint0_linear_409_2859)"
        />
      </g>
      <path
        d="M50.7266 25.885H38.7124C38.1601 25.885 37.7124 26.3327 37.7124 26.885V30.0379C37.7124 30.5902 38.1601 31.0379 38.7124 31.0379H50.7266C51.2789 31.0379 51.7266 30.5902 51.7266 30.0379V26.885C51.7266 26.3327 51.2789 25.885 50.7266 25.885Z"
        fill="#D8DDEB"
      />
      <path
        d="M100.961 25.885H88.9467C88.3944 25.885 87.9467 26.3327 87.9467 26.885V30.0379C87.9467 30.5902 88.3944 31.0379 88.9467 31.0379H100.961C101.513 31.0379 101.961 30.5902 101.961 30.0379V26.885C101.961 26.3327 101.513 25.885 100.961 25.885Z"
        fill="#D8DDEB"
      />
      <g filter="url(#filter1_d_409_2859)">
        <path
          d="M48.724 14.1934H40.7246C40.1723 14.1934 39.7246 14.6411 39.7246 15.1934V27.2586C39.7246 27.8109 40.1723 28.2586 40.7246 28.2586H48.724C49.2763 28.2586 49.724 27.8109 49.724 27.2586V15.1934C49.724 14.6411 49.2763 14.1934 48.724 14.1934Z"
          fill="url(#paint1_linear_409_2859)"
        />
      </g>
      <g filter="url(#filter2_d_409_2859)">
        <path
          d="M98.9582 14.1934H90.9589C90.4066 14.1934 89.9589 14.6411 89.9589 15.1934V27.2586C89.9589 27.8109 90.4066 28.2586 90.9589 28.2586H98.9582C99.5105 28.2586 99.9582 27.8109 99.9582 27.2586V15.1934C99.9582 14.6411 99.5105 14.1934 98.9582 14.1934Z"
          fill="url(#paint2_linear_409_2859)"
        />
      </g>
      <path
        d="M52.282 59.0742C56.5202 59.0742 59.9559 55.6385 59.9559 51.4003C59.9559 47.1621 56.5202 43.7263 52.282 43.7263C48.0438 43.7263 44.608 47.1621 44.608 51.4003C44.608 55.6385 48.0438 59.0742 52.282 59.0742Z"
        stroke="#939DAE"
        strokeWidth={4}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.9572 71.6347C39.9572 64.8909 45.5382 59.3098 52.282 59.3098C59.0257 59.3098 64.6068 64.8909 64.6068 71.6347"
        stroke="#939DAE"
        strokeWidth={4}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M77.3967 50.0051H102.279"
        stroke="#939DAE"
        strokeWidth={4}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M77.3967 62.5625H87.1636"
        stroke="#939DAE"
        strokeWidth={4}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M75.2171 94.0454H71.5888V90.4171C71.5888 89.6915 71.0244 89.0464 70.2181 89.0464C69.4925 89.0464 68.8475 89.6108 68.8475 90.4171V94.0454H65.2192C64.4935 94.0454 63.8485 94.6098 63.8485 95.4161C63.8485 96.2224 64.4129 96.7868 65.2192 96.7868H68.8475V100.415C68.8475 101.141 69.4119 101.786 70.2181 101.786C70.9438 101.786 71.5888 101.221 71.5888 100.415V96.7868H75.2171C75.9427 96.7868 76.5878 96.2224 76.5878 95.4161C76.5878 94.6098 75.9427 94.0454 75.2171 94.0454Z"
        fill="white"
      />
    </g>
    <path
      d="M49.6846 105.677L66.0224 79.8196C67.8004 77.3935 71.5234 77.3935 73.3014 79.8196L89.6394 105.677C91.3614 107.995 89.6394 111.284 86.6944 111.284H52.6854C49.6846 111.23 47.9619 107.995 49.6846 105.677Z"
      fill="url(#paint3_linear_409_2859)"
    />
    <path
      d="M69.6616 86.4392C68.1046 86.4392 66.8936 87.8077 67.0096 89.4143L67.8746 99.0536C67.9316 100.006 68.7386 100.779 69.6616 100.779C70.5846 100.779 71.3916 100.006 71.4486 99.0536L72.3136 89.4143C72.4296 87.7482 71.2186 86.4392 69.6616 86.4392Z"
      fill="white"
    />
    <path
      d="M69.6619 102.564C68.5089 102.564 67.5859 103.516 67.5859 104.706C67.5859 105.896 68.5089 106.848 69.6619 106.848C70.8149 106.848 71.7379 105.896 71.7379 104.706C71.7379 103.516 70.8149 102.564 69.6619 102.564Z"
      fill="white"
    />
    <defs>
      <filter
        id="filter0_d_409_2859"
        x={0.981445}
        y={12.4951}
        width={138.413}
        height={109.345}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={11} />
        <feGaussianBlur stdDeviation={11} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_409_2859"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_409_2859"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_409_2859"
        x={17.7246}
        y={3.19336}
        width={53.9994}
        height={58.0652}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={11} />
        <feGaussianBlur stdDeviation={11} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_409_2859"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_409_2859"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_d_409_2859"
        x={67.9589}
        y={3.19336}
        width={53.9993}
        height={58.0652}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={11} />
        <feGaussianBlur stdDeviation={11} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_409_2859"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_409_2859"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_409_2859"
        x1={70.1571}
        y1={21.9836}
        x2={70.1571}
        y2={89.5444}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FDFEFF" />
        <stop offset={0.9964} stopColor="#ECF0F5" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_409_2859"
        x1={44.721}
        y1={13.868}
        x2={44.721}
        y2={28.4102}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FDFEFF" />
        <stop offset={0.9964} stopColor="#ECF0F5" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_409_2859"
        x1={94.9553}
        y1={13.868}
        x2={94.9553}
        y2={28.4102}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FDFEFF" />
        <stop offset={0.9964} stopColor="#ECF0F5" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_409_2859"
        x1={69.666}
        y1={79.1562}
        x2={69.666}
        y2={97.8381}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF6565" />
        <stop offset={1} stopColor="#FE0F0F" />
      </linearGradient>
      <clipPath id="clip0_409_2859">
        <rect width={140} height={122} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgDiscardSelection;
